export default __webpack_public_path__ + "static/media/selection.65508500.svg";